import { render } from "./Button.vue?vue&type=template&id=96405ede"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Button.vue?vue&type=style&index=0&id=96405ede&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script